import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Button,
} from "@mui/material";
import { Box } from "@mui/material";
import ProgressCom from "../../../components/ProgressCom";
import CustomPagination from "../../../components/CustomPagination";
import { DataGrid, faIR } from "@mui/x-data-grid";
import ClearIcon from "@mui/icons-material/Clear";
import { UseDiscountCode } from "./UseDiscountCode";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteRow from "../../../components/DeleteRow";
import DeleteIcon from "@mui/icons-material/Delete";
import { rsProgress } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { useSnackbar } from "notistack";
import SearchComOff from "../../../ContentManagement/firstPage/HomeOffer/SearchComOff";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export default function CodeProduct(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const {
    getDiscountCodeProduct,
    addDiscountCodeProduct,
    deleteDiscountCodeProduct,
  } = UseDiscountCode();
  const [products, setProducts] = useState([]);
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [addUser, setAddUser] = useState(false);
  const [stateAdd, setStateAdd] = useState({
    discountID: props.DiscountID,
    productID: "",
  });

  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  useEffect(() => {
    if (props.DiscountID) {
      setProgress(true);
      getDiscountCodeProduct(props.DiscountID, (callback) => {
        setProducts(callback);
      });
    }
  }, [props.DiscountID]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "productName",
      width: 230,
      align: "center",
      headerName: "نام محصول",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.productName}
          </Typography>
        );
      },
    },
    {
      field: "حذف",
      sortable: false,
      width: 90,
      headerAlign: "center",
      align: "center",
      headerName: "حذف",
      renderCell: (cellValues) => {
        return (
          <IconButton
            onClick={() => {
              setDeleteState({
                show: true,
                name: cellValues.row.productID,
                id: cellValues.row.id,
              });
            }}
          >
            <DeleteIcon sx={{ color: "MyColor.main" }} />
          </IconButton>
        );
      },
    },
    {
      field: "addUser",
      width: 60,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <IconButton
            onClick={() => {
              setAddUser(true);
            }}
          >
            <AddCircleIcon sx={{ color: "primary.main" }} />
          </IconButton>
        );
      },
    },
  ];

  return (
    <Dialog
      PaperProps={
        {
          // elevation: 1,
        }
      }
      sx={{ zIndex: 200 }}
      fullWidth
      open={props.showProducts}
      onClose={() => props.setShowProducts(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        sx={{ p: 1, px: 2 }}
        color="secondary"
        id="alert-dialog-title"
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {!addUser ? (
            <Typography color="secondary" variant="subtitle2">
              لیست محصولات
            </Typography>
          ) : (
            <Typography variant="subtitle2">محصول را انتخاب کنید</Typography>
          )}
          {!addUser ? (
            <IconButton
              onClick={() => {
                props.setShowProducts(false);
              }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          ) : (
            <IconButton
              onClick={() => {
                setAddUser(false);
              }}
            >
              <ArrowBackIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      </DialogTitle>
      <DialogContent>
        {!addUser ? (
          <Box sx={{ height: "18rem" }}>
            {products ? (
              <DataGrid
                localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
                columns={columns}
                rows={products ? products : []}
                page={pageState.page - 1}
                pageSize={20}
                Pagination
                onPageChange={(newPage) => {
                  setPageState((old) => ({ ...pageState, page: newPage + 1 }));
                }}
                rowCount={products && products.length ? products.length : 1}
                disableColumnMenu
                hideFooterSelectedRowCount
                components={{
                  Pagination: CustomPagination,
                }}
                componentsProps={{
                  pagination: {
                    nofab: true,
                    noPageCount: true,
                    rowCount:
                      products && products.length ? products.length : "",
                  },
                }}
                initialState={{
                  sorting: {
                    sortModel: [
                      {
                        field: "id",
                        sort: "asc",
                      },
                    ],
                  },
                }}
              />
            ) : (
              <ProgressCom></ProgressCom>
            )}
          </Box>
        ) : (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              mt: 1,
            }}
          >
            <SearchComOff
              codeProduct
              productID={stateAdd.productID}
              productModel={stateAdd}
              setProductModel={setStateAdd}
            />
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mt: 3,
              }}
            >
              <Button
                variant="contained"
                sx={{ mr: 2 }}
                onClick={() => {
                  if (!stateAdd.productID) {
                    enqueueSnackbar("محصول را انتخاب کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  }
                  addDiscountCodeProduct(stateAdd, () => {
                    setProgress(true);
                    getDiscountCodeProduct(stateAdd.discountID, (callback) => {
                      setProducts(callback);
                    });
                    props.callback(props.DiscountID);
                    setAddUser(false);
                    setStateAdd({ ...stateAdd, productID: "" });
                  });
                }}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    if (!stateAdd.productID) {
                      enqueueSnackbar("محصول را انتخاب کنید", {
                        variant: "error",
                        autoHideDuration: 2000,
                        preventDuplicate: true,
                      });
                      return;
                    }
                    addDiscountCodeProduct(stateAdd, () => {
                      setProgress(true);
                      getDiscountCodeProduct(
                        stateAdd.discountID,
                        (callback) => {
                          setProducts(callback);
                        }
                      );
                      props.callback(props.DiscountID);
                      setAddUser(false);
                      setStateAdd({ ...stateAdd, productID: "" });
                    });
                  }
                }}
              >
                ثبت
              </Button>
              <Button
                onClick={() => props.setShowProducts(false)}
                color="secondary"
                variant="outlined"
              >
                انصراف
              </Button>
            </Box>
          </Box>
        )}
        <DeleteRow
          deleteState={deleteState}
          setDeleteState={setDeleteState}
          type={"محصول"}
          callback={() => {
            setProgress(true);
            deleteDiscountCodeProduct(deleteState.id, () => {
              getDiscountCodeProduct(props.DiscountID, (callback) => {
                props.callback(props.DiscountID);
                setProducts(callback);
              });
            });
          }}
        ></DeleteRow>
      </DialogContent>
    </Dialog>
  );
}
